import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const BaselineErrorIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="#FFF"
    {...props}>
    <Path fill="none" d="M0 0h24v24H0z" />
    <Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
  </Svg>
);
export default BaselineErrorIcon;
